import Joi from '@hapi/joi'

export const routeSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Factory Name").messages({
        "any.invalid": `Factory Name cannot have invalid characters`,
        "any.required": `Factory Name characters`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Catagory Type").messages({
        "any.invalid": `Collection Catagory Type cannot have invalid characters`,
        "any.required": `Collection Catagory Type characters`
    }),
    collectionPointCode: Joi.string().required().invalid("00").min(2).max(2).label("Route Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Route Code required`,
        "string.pattern.base": `Route Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as route code`
    }),
    collectionPointName: Joi.string().required().label("Route Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Route Name required`,
        "string.pattern.base": `Please enter valid ruote name`,
    }),
    collectionPointLocation: Joi.string().allow("", null).label("Route Location"),
    isActive: Joi.boolean().label("Active"),
    factoryWeighValidationEnabled: Joi.boolean().label("Factory Weigh Validation")
}

export const routeFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please Select the Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please Select the Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionCatagoryID: Joi.number().required().label("Collection Catagory").messages({
        "any.invalid": `Please Select the Collection Catagory`,
        "any.required": `CollectionCatagory required`
    })
}